export default class ModelValidationError extends Error {

}